import React from "react";
import { AnalyticsLayoutTemplate } from "themes/administration/analytics/layouts";

function AnalyticsLayout(props) {
    return <AnalyticsLayoutTemplate {...props} />;
}

export default AnalyticsLayout;
